import { chatNewMessagesStr } from '../../../../../chat/modules/common';
import React, { Fragment, PureComponent } from 'react';
import SvgIcon from '../../../../../common/SvgIcon';
import cn from 'classnames';
import PopOver from '../../../../../common/components/PopOver';
import { getChatCaption, getChatName, staffedServiceTypes } from '../contstants/constants';

// The designer / shopping support the room is with. Falls back to their
// initials while they have no avatar uploaded, and to an empty circle while
// nobody is assigned - the caption underneath says which room it is either way.
const RoomAvatar = ({ chat }) => {
  const { assignee } = chat;

  if (!assignee) {
    return <div className="chat-popup_room-avatar -empty" />;
  }

  const styles = assignee.avatar ? { backgroundImage: `url(${assignee.avatar})` } : {};

  return (
    <div style={styles} className="chat-popup_room-avatar">
      {!assignee.avatar && <span>{assignee.initials}</span>}
    </div>
  );
};

const RoomsList = ({ chats, setActiveChat, chatFullsize }) => {
  return (
    <div className="chat-popup_rooms-scroll">
      {chats.map(chatRoom => (
        <PopOver
          direction={!chatFullsize ? 'left' : 'right'}
          key={chatRoom.id}
          title={getChatName(chatRoom)}
        >
          <div
            className={cn('chat-popup_rooms-list_item', { '-active': chatRoom.active })}
            onClick={() => setActiveChat(chatRoom)}
          >
            <div className="chat-popup_rooms-list_item_person">
              <div className="icon">
                {staffedServiceTypes.includes(chatRoom.service_type) ? (
                  <RoomAvatar chat={chatRoom} />
                ) : (
                  <SvgIcon
                    icon={`icon-chat-${chatRoom.service_type || 'general'}`}
                    key={chatRoom.id}
                    className="chat-popup_room-type-icon"
                  />
                )}
                {Boolean(chatRoom.new_messages_count) && (
                  <div className="new-messages-count">
                    {chatNewMessagesStr(chatRoom.new_messages_count)}
                  </div>
                )}
              </div>
              <div className="chat-popup_rooms-list_item_caption">{getChatCaption(chatRoom)}</div>
            </div>
            <div className="chat-popup_rooms-list_item_chat-name">{getChatName(chatRoom)}</div>
          </div>
        </PopOver>
      ))}
    </div>
  );
};

export default RoomsList;



// WEBPACK FOOTER //
// ./app/javascript/customer_chat/components/chat/shared/components/RoomsList.js